import { PageError } from './types';

export const disableLoading = () =>
  ({
    type: 'APP_DISABLE_LOADING',
  } as const);

export const enableLoading = () =>
  ({
    type: 'APP_ENABLE_LOADING',
  } as const);

export const setIsMobile = (isMobile: boolean) =>
  ({
    type: 'SET_IS_MOBILE',
    payload: isMobile,
  } as const);

export const setPageError = (error: PageError) =>
  ({
    type: 'SET_PAGE_ERROR',
    payload: error,
  } as const);

export const cleanPageError = () =>
  ({
    type: 'CLEAN_PAGE_ERROR',
  } as const);

export const setRecaptchaToken = (recaptchaToken: string) =>
  ({
    type: 'SET_RECAPTCHA_TOKEN',
    payload: recaptchaToken,
  } as const);
